import './Heading-26b4879b.css';

var classes = {"Heading":"prc-Heading-Heading-6CmGO"};

export { classes as default };
